import type { Locale } from '@seek/melways-sites';

import type { Country } from './Country';

// Currency code in uppercase according to ISO 4217 https://en.wikipedia.org/wiki/ISO_4217
export const currency = [
  'AUD',
  'HKD',
  'IDR',
  'MYR',
  'NZD',
  'PHP',
  'SGD',
  'THB',
  'USD',
] as const;

export type Currency = (typeof currency)[number];

export const parseCurrency = (currencyInput: string): Currency => {
  if (currency.includes(currencyInput as Currency)) {
    return currencyInput as Currency;
  }
  throw new Error(`Currency ${currencyInput} is not supported`);
};

// format currency format based on locale according to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
export const formatCurrency = (
  amount: number,
  currencyInput: string = '',
  locale?: Locale,
) =>
  new Intl.NumberFormat(locale ?? 'id-ID', {
    style: 'currency',
    currency: currencyInput,
    currencyDisplay: 'code',
  }).format(amount);

// return currency based on supported country
export const getPaymentCurrency = (country: Country): Currency => {
  switch (country) {
    case 'NZ':
      return 'NZD';
    case 'AU':
      return 'AUD';
    case 'ID':
      return 'IDR';
    case 'PH':
      return 'PHP';
    case 'SG':
      return 'SGD';
    case 'MY':
      return 'MYR';
    case 'HK':
      return 'HKD';
    case 'TH':
      return 'THB';
    default:
      return 'AUD';
  }
};
